

































































import Vue from "vue";
import iwBasicInfo from "./views/BasicInfo.vue";
import iwPictures from "@/optimizedEncoding/views/Pictures.vue";
import iwDescription from "./components/Description.vue";
import iwPackSelection from "@/optimizedEncoding/views/PackSelection.vue";
import iwContactInformation from "@/optimizedEncoding/views/ContactInformation.vue";
import iwPreview from "@/optimizedEncoding/views/Preview.vue";
import iwPayment from "@/optimizedEncoding/views/Payment.vue";
import { getClassifiedId } from "@/shared/scripts/ClassifiedsApi";
import "@/assets/sass/optimizedEncoding/optimizedEncoding.scss";

export default Vue.extend({
    name: "OptimizedEncoding",
    components: {
        iwBasicInfo: iwBasicInfo,
        iwPackSelection: iwPackSelection,
        iwPictures: iwPictures,
        iwDescription: iwDescription,
        iwPreview: iwPreview,
        iwContactInformation: iwContactInformation,
        iwPayment: iwPayment,
    },
    data: function() {
        return {
            activeSections: {
                basicInfo: true,
                pictures: false,
                description: false,
                packSelection: false,
                preview: false,
                contactInformation: false,
                payment: false
            } as Record<string, boolean>,
            sectionOrder: ["basicInfo", "packSelection","pictures", "description", "preview", "contactInformation", "payment"] as string[],
        };
    },
    computed: {
        isPicturesSectionVisible: function(): boolean {
            return Boolean(this.activeSections.pictures);
        },
        isDescriptionSectionVisible: function(): boolean {
            return Boolean(this.activeSections.description);
        },
        isPackSelectionSectionVisible: function(): boolean {
            return Boolean(this.activeSections.packSelection);
        },
        isContactInformationSectionVisible: function(): boolean {
            return Boolean(this.activeSections.contactInformation);
        },
        isPaymentSectionVisible: function(): boolean {
            return Boolean(this.activeSections.payment);
        },
        isPreviewSectionVisible: function(): boolean {
            return Boolean(this.activeSections.preview);
        },
    },
    mounted: function() {
        const classifiedId = this.$route.params.id;
        if (classifiedId) {
            getClassifiedId(classifiedId).then((success) => {
                if (success) {
                    // Enable sections based on available data
                    this.enableSectionsBasedOnData();
                }
            }).catch(error => {
                console.error("Failed to load classified data:", error);
            });
        }
    },
    methods: {
        enableSectionsBasedOnData: function() {
            const hasBasicInfo = this.$store.getters["FormModule/getValue"]("transaction.type") &&
                (this.$store.getters["FormModule/getValue"]("transaction.sale.price") || this.$store.getters["FormModule/getValue"]("transaction.rental.monthlyRentalPrice"));
            const hasPictures = this.$store.getters["PicturesModule/getPictures"]?.length > 0;
            const hasDescription = this.$store.getters["FormModule/getValue"]("property.title") || 
                this.$store.getters["FormModule/getValue"]("property.description");
            const classifiedId = this.$route.params.id;

            this.activeSections.basicInfo = true;
            this.activeSections.packSelection = Boolean(hasBasicInfo && classifiedId);
            this.activeSections.pictures = Boolean(hasBasicInfo && hasPictures);
            this.activeSections.description = Boolean(hasBasicInfo && (hasPictures || hasDescription));
            this.activeSections.preview = Boolean(hasBasicInfo && hasPictures && hasDescription);
            this.activeSections.contactInformation = false;
            this.activeSections.payment = false;
        },
        handleSectionCompleted: function(sectionName: string) {
            const currentIndex = this.sectionOrder.indexOf(sectionName);
            const nextSection = this.sectionOrder[currentIndex + 1];
            
            if (nextSection) {
                this.$set(this.activeSections, nextSection, true);
                this.$nextTick(() => {
                    const nextRef = this.$refs[nextSection] as Vue;
                    if (nextRef && nextRef.$el) {
                        nextRef.$el.scrollIntoView({ behavior: "smooth", block: "start" });
                    }
                });
            }
        },
        handleSectionUncompleted: function(sectionName: string) {
            const currentIndex = this.sectionOrder.indexOf(sectionName);            
            const sectionToHide = this.sectionOrder[currentIndex];

            // if basicInfo is uncompleted, hide all subsequent sections
            if (sectionName === "basicInfo") {
                for (let i = currentIndex; i < this.sectionOrder.length; i++) {
                    this.$set(this.activeSections, this.sectionOrder[i + 1], false);
                }
                return;
            }

            this.$set(this.activeSections, sectionToHide, false);
            
            // If packSelection is uncompleted, also hide contactInformation and payment sections
            if (sectionName === "packSelection") {
                this.$set(this.activeSections, "contactInformation", false);
                this.$set(this.activeSections, "payment", false);
            }
        }
    },
});
